<div class="modal-dialog">
                <div class="modal-content">
                   <div class="modal-header">
                     <a (click)="close()" title="Close" class="close" style="cursor: pointer" data-dismiss="modal"></a>
                     <h4 class="modal-title">{{title || 'Confirm'}}</h4>
                   </div>
                   <div class="modal-body">
                     <p style="text-align: center;" [innerHTML]="message || 'Are you sure?'"></p>
                   </div>
                   <div class="modal-footer center" style="text-align: center; margin-bottom: 2em;">
                     <!-- <button type="button" class="btn btn-primary" (click)="confirm()">OK</button>
         <button type="button" class="btn btn-default" (click)="close()" >Cancel</button> -->
                   </div>
                 </div>
              </div>